import { actionRegistry } from './action-registry';
import { registerActions } from './register-actions';

/**
 * Side-effect entry point for the action registry.
 *
 * Imported from main.ts after `./services` (DI container registrations)
 * and before `./components` so actions are available at component initialization.
 *
 * This module-level call registers all 15 application actions synchronously.
 * No unit test needed — import order verified by build (T8.13) and E2E test (T8.14).
 */
registerActions(actionRegistry);
